export default __webpack_public_path__ + "static/media/credit-card.19eb2122.svg";